import { fetchCampaignModifiersQuery } from 'api/queries/campaigns';
import { useGraphql } from 'utils/hooks/useGraphql';
import { User } from '../types';

type CampaignModifiersResponse = {
  campaignModifiers: User[];
};

export const useCampaignModifiers = () => {
  const {
    data: { campaignModifiers = [] } = {},
    isLoading,
    error,
  } = useGraphql<CampaignModifiersResponse>(fetchCampaignModifiersQuery);

  return { campaignModifiers, isLoading, error };
};
